@import '../../styles/variables.scss';

.option-name {
  font-size: 0.75rem;
  font-weight: 500;
  margin-bottom: 0.125rem;
  color: var(--bs-body-color);
}

.option-values {
  display: flex;

  .option-value {
    min-width: 2.75rem;
    border: 1px solid var(--bs-border-color);
    border-radius: 0;
    transition: none;

    &:hover:not(:disabled) {
      background-color: transparent;
      border-color: var(--bs-body-color);

      + .option-value {
        border-left-color: transparent;
      }
    }

    &:focus {
      outline: none;
    }

    &.active {
      border-color: var(--button-secondary-active-border-color);
      font-weight: 700;

      + .option-value {
        border-left-color: transparent;
      }
    }

    &:not(:hover):not(.active):not(:last-child) {
      border-right-color: transparent;
    }

    // e.g. a sold out size
    &.unavailable {
      border-color: var(--bs-border-color);
      text-decoration: line-through;
      cursor: not-allowed;
    }
  }
}
